import { sortByDateReverse } from './utils'

export function getList(listName){
    return async function(dispatch){
        dispatch({
            type: "GET_ALL_DEVIS_START",
            payload: ""
        })
            
        console.log('====================================');
        console.log("GET LIST START", listName);
        console.log('====================================');

        try {
            const response = await fetch('/quotation/prospect/get', {
                method: 'POST',
                body: JSON.stringify({type: listName}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const res = await response.json();
            console.log("GET LIST DEVIS", {res});
            if (res.error ){
                console.log("[ERROR], get list response ",res)                   
                // dispatch({
                //     type: "ASK_DEVIS_ERROR",
                //     payload: res.error.message
                    
                // })
                return;
            }
            dispatch({
                type: "GET_ALL_DEVIS",
                payload: res.list[0]
                
            })
            dispatch({ type: "GET_ALL_DEVIS_FULFILLED", payload:"" })
            
        } catch (err) {
            console.log("[ERROR],  get list ",err)
            dispatch({
                type: "GET_ALL_DEVIS_ERROR",
                payload: err
                
            })
        }
    }
}
export function getClientInfoList(prospectID){
    return async function(dispatch){
        // dispatch({
        //     type: "ASK_DEVIS_START",
        //     payload: ""
            
        // })
        console.log('====================================');
        console.log("getClientInfoList START", prospectID);
        console.log('====================================');

        try {
            const response = await fetch('/quotation/prospect/getClientInfo', {
                method: 'POST',
                body: JSON.stringify({boxAssoId: prospectID}),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const res = await response.json();
            console.log("GET LIST DEVIS", {res});
            if (res.error ){
                console.log("[ERROR], get list response ",res)                   
                // dispatch({
                //     type: "ASK_DEVIS_ERROR",
                //     payload: res.error.message
                    
                // })
                return;
            }
            let list = res.body.actionList ? sortByDateReverse(res.body.actionList, "timeAction") : []
            dispatch({
                type: "GET_ACTIONS_PROSPECT",
                payload: {
                    [prospectID]: list
                }
            })                
            dispatch({ type: "GET_ACTIONS_PROSPECT_FULFILLED", payload:"" })
        } catch (err) {
            console.log("[ERROR],  get list ",err)
            dispatch({
                type: "GET_ACTIONS_PROSPECT_ERROR",
                payload: err
                
            })
        }
    }
}
export function askDevis(client){
    return async function(dispatch){
        dispatch({ type: "ASK_DEVIS_START", payload: "" })
        try {
            const response = await fetch('/quotation/prospect/addtolist', {
                method: 'POST',
                body: JSON.stringify({
                    prospectID: client.ID
                }),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const res = await response.json();
            console.log(res);
            if (res.msg != "OK" ){
                console.log("[ERROR], ask for devis response ",res)                   
                dispatch({
                    type: "ASK_DEVIS_ERROR",
                    payload: res.error.message.content
                })
                return;
            }
            dispatch({
                type: "ASK_DEVIS_ADD",
                payload: client             
            })

            dispatch({ type: "ASK_DEVIS_FULFILLED", payload:"" })
            
        } catch (err) {
            console.log("[ERROR], ask for devis data",err)
            dispatch({
                type: "ASK_DEVIS_ERROR",
                payload: err
                
            })
        }
    }
}
export function createAction(lastStatus, newAction){
    console.log("FIRED ACTION CREATE ACTION", newAction)
    return async function(dispatch){
        dispatch({
            type: "CREATE_ACTION_START",
            payload: "" 
        })
        try {
            const response = await fetch('/quotation/prospect/action/new', {
                method: 'POST',
                body: JSON.stringify( newAction ),
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
            });            
            const resp = await response.json();
            console.log(resp);
            if (resp.msg != "OK" ){
                console.log("[ERROR], create action response ",resp)                   
                dispatch({
                    type: "CREATE_ACTION_ERROR",
                    payload: resp.error.message
                    
                })
                return;
            }
            dispatch({
                type: "NEW_ACTION",
                payload: {newAction, lastStatus}
            })
            
                
            dispatch({ type: "CREATE_ACTION_FULFILLED", payload:"" })
            
            
        } catch (err) {
            console.log("[ERROR], create devis ",err)
            dispatch({
                type: "CREATE_DEVIS_ERROR",
                payload: err
                
            })
        }
    }
}
export function deleteDevis(client){
    return {
        type: "DELETE",
        payload: client
        
    }
}